export default (state = [], action) => {
    let { type, payload } = action
    switch (type) {
        case 'HUNT_PLANNER_STATES_DATA':
            return payload
        case 'LOGOUT':
            return []
        default:
            return state
    }
}
